import { useAuth } from "@k3-tech/react-kit";
import { useMemo } from "react";

export type UserBranchOption = {
	branchID: string;
	branchCode: string;
	branchName: string;
};

// useUserBranches surfaces the current user's accessible branches from the
// auth session. Lists that should respect branch access (rental approval,
// branch-scoped reports, …) call this to drive both the filter dropdown
// and the auto-scope filter on the underlying list query.
export default function useUserBranches() {
	const { session } = useAuth();
	const isAllBranches = Boolean(session?.meta?.isAllBranches);
	const branches = useMemo(() => {
		const raw = (session?.meta?.branches ?? []) as Array<
			| {
					branchID?: string | null;
					branchCode?: string | null;
					branchName?: string | null;
			  }
			| null
			| undefined
		>;
		return raw
			.filter((b): b is NonNullable<typeof b> => Boolean(b?.branchID))
			.map((b) => ({
				branchID: b.branchID as string,
				branchCode: b.branchCode ?? "",
				branchName: b.branchName ?? "",
			})) satisfies UserBranchOption[];
	}, [session?.meta?.branches]);
	const branchIDs = useMemo(() => branches.map((b) => b.branchID), [branches]);
	return { branches, branchIDs, isAllBranches };
}
